import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { DropdownPosition } from '@ng-select/ng-select';

@Component({
  selector: 'table-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PaginationComponent implements OnInit {
  pageSize!: number;
  pageIndex!: number;
  length!: number;
  currentPage!: number;
  pageNumbers!: number[];
  takes: number[] = [10, 25, 50, 100, 250, 500];
  @Input() disabled = false;
  @Input() hidePageSize = false;
  @Input() pageSizeOptions!: number[];
  @Input() showFirstLastButtons = true;
  @Input() searchable: boolean = false;
  @Input() dropdownPosition: DropdownPosition = 'top';
  @Output() page = new EventEmitter<PageEvent>();

  @Input('pageIndex') set pageIndexChanged(pageIndex: number) {
    this.pageIndex = pageIndex;
    this.updateCurrentPage();
  }
  @Input('length') set lengthChanged(length: number) {
    this.length = length;
    this.updateCurrentPage();
  }
  @Input('pageSize') set pageSizeChanged(pageSize: number) {
    this.pageSize = pageSize;
    this.updateCurrentPage();
  }

  constructor() {}

  ngOnInit() {
    this.updateCurrentPage();
  }

  updateCurrentPage() {
    this.currentPage = (this.pageIndex || 0) + 1;
    this.pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.length / this.pageSize); i++) {
      this.pageNumbers.push(i);
    }
  }

  paginationChange(pageEvt: PageEvent) {
    this.length = pageEvt.length;
    this.pageIndex = pageEvt.pageIndex;
    this.pageSize = pageEvt.pageSize;
    this.updateCurrentPage();
    this.emitPageEvent(pageEvt);
  }

  currentPageChange() {
    const event: PageEvent = {
      length: this.length,
      pageIndex: this.currentPage - 1,
      pageSize: this.pageSize,
    };
    this.emitPageEvent(event);
  }

  emitPageEvent(pageEvent: PageEvent) {
    this.page.next(pageEvent);
  }

  currentTakeChange() {
    const event: PageEvent = {
      length: this.length,
      pageIndex: this.currentPage - 1,
      pageSize: this.pageSize,
    };
    this.emitPageEvent(event);
  }

  toFirstPage() {
    const event: PageEvent = {
      length: this.length,
      pageIndex: 0,
      pageSize: this.pageSize,
    };
    this.page.next(event);
  }

  toLastPage() {
    const event: PageEvent = {
      length: this.length,
      pageIndex: (this.pageNumbers.at(-1) || 1) - 1,
      pageSize: this.pageSize,
    };
    this.page.next(event);
  }

  toNextPage() {
    const event: PageEvent = {
      length: this.length,
      pageIndex: this.pageIndex + 1,
      pageSize: this.pageSize,
    };
    this.page.next(event);
  }

  toPrevPage() {
    const event: PageEvent = {
      length: this.length,
      pageIndex: this.pageIndex - 1,
      pageSize: this.pageSize,
    };
    this.page.next(event);
  }

  disabledBeforeBtn() {
    if (!this.currentPage) return false;
    return this.currentPage === 1;
  }

  disabledAfterBtn() {
    if (!this.pageNumbers?.length) return false;
    return this.pageNumbers.length === 1 || this.pageNumbers.at(-1) === this.currentPage;
  }
}
